import './styles/globals.css'
import "./css/bootstrap.min.css";
import "./css/remixicon.css";
import "./css/flaticon.css";
import "./css/header.css";
import "./css/footer.css";
import "./css/dark-switch-btn.css";
import 'swiper/css/bundle';
import 'react-accessible-accordion/dist/fancy-example.css';

// Globals Style
import "./css/globals.css";
import "./css/responsive.css";
// Dark Mode Style
import './css/dark-mode.css'

import Router from "./router/index";
 
import './App.css';

function App() {
  return (
    <Router />
  );
}

export default App;
